import { ShopsMenu as ShopsMenuV1 } from 'app/menu/components/TopBarV1/Shops'

export const ShopsMenu = ShopsMenuV1
export default ShopsMenu
